import styled from 'styled-components';

import { Text as TextLayoutComponent, ScrollBarContainer } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const DndMessage = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  text-align: center;
`;

export const AddGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;

  @media (min-width: 768px) {
    height: 150px;
    width: 180px;
  }

  @media (min-width: 1024px) {
    width: 220px;
  }
`;

export const ContainerGrid = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-auto-rows: 8px;

  @media (min-width: 768px) {
    grid-auto-rows: 20px;
    grid-template-columns: repeat(auto-fill, minmax(23.5%,1fr));
  }
`;

export const Item = styled.div``;

export const Content = styled.div``;

export const Text = styled(TextLayoutComponent)``;

export const Link = styled.a``;

export const ScrollBar = styled(ScrollBarContainer)``;
